import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchSettings = useCallback(async () => {
        try {
            const { data } = await api.get("/site-settings");
            setSettings(data || {});
        } catch {
            setSettings({});
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchSettings(); }, [fetchSettings]);

    const t = useCallback((key, fallback = "") => {
        const v = settings[key];
        return v == null || v === "" ? fallback : v;
    }, [settings]);

    return (
        <SettingsContext.Provider value={{ settings, loading, t, refresh: fetchSettings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    const ctx = useContext(SettingsContext);
    if (!ctx) throw new Error("useSettings must be used within SettingsProvider");
    return ctx;
}
